import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, Send } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";

export default function TesterEmailsPanel({ config }) {
  const [f, setF] = useState({ tester_emails_enabled: false, tester_group_url: "", tester_seq_start: "2026-11-23" });
  const [saving, setSaving] = useState(false);
  const [sending, setSending] = useState(false);
  useEffect(() => {
    if (config) setF({ tester_emails_enabled: !!config.tester_emails_enabled, tester_group_url: config.tester_group_url || "", tester_seq_start: config.tester_seq_start || "2026-11-23" });
  }, [config]);

  const save = async () => {
    setSaving(true);
    try { await api.put("/super-admin/billing", { ...f, tester_group_url: f.tester_group_url.trim() }); toast.success("Email tester salvate"); }
    catch (e) { toast.error(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Controlla il link del gruppo (deve iniziare con https://) e la data"); }
    setSaving(false);
  };
  const preview = async () => {
    setSending(true);
    try { const { data } = await api.post("/super-admin/tester-emails/preview"); toast.success(`5 email di anteprima inviate a ${data.sent_to}`); }
    catch (e) { toast.error(e?.response?.data?.detail || "Invio non riuscito"); }
    setSending(false);
  };

  return (
    <div data-testid="tester-emails-panel" className="bg-card border border-slate-200/80 rounded-xl shadow-sm p-6 max-w-xl mt-6 space-y-4">
      <h2 className="text-base font-semibold text-slate-900 flex items-center gap-2"><Mail style={{ width: 18, height: 18 }} className="text-primary" /> Email tester</h2>
      <div className="flex items-center justify-between gap-4 rounded-lg border border-border p-4">
        <div>
          <p className="text-sm font-medium text-slate-900">Sequenza email tester attiva</p>
          <p className="text-xs text-slate-500">5 email automatiche ai tester: benvenuto, gruppo, primo preventivo, Offerta Fondatore e fase guidata.</p>
        </div>
        <Switch data-testid="tester-emails-switch" checked={f.tester_emails_enabled} onCheckedChange={(v) => setF((s) => ({ ...s, tester_emails_enabled: v }))} />
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Link del gruppo Facebook dei tester</label>
        <Input data-testid="tester-group-url-input" value={f.tester_group_url} maxLength={300} className="mt-1.5"
          onChange={(e) => setF((s) => ({ ...s, tester_group_url: e.target.value }))} placeholder="https://www.facebook.com/groups/..." />
        <p className="text-xs text-slate-500 mt-1">Senza link, le email 2 e 5 restano in attesa.</p>
      </div>
      <div>
        <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Inizio sequenza</label>
        <Input type="date" data-testid="tester-seq-start-input" value={f.tester_seq_start} className="font-mono mt-1.5 sm:w-56"
          onChange={(e) => setF((s) => ({ ...s, tester_seq_start: e.target.value }))} />
        <p className="text-xs text-slate-500 mt-1">Le email 1–4 vanno solo a chi è diventato tester da questa data in poi.</p>
      </div>
      <div className="flex gap-2 flex-wrap">
        <Button data-testid="tester-emails-save" onClick={save} disabled={saving} className="font-semibold">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salva"}
        </Button>
        <Button data-testid="tester-emails-preview" variant="outline" onClick={preview} disabled={sending} className="font-semibold">
          {sending ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Send style={{ width: 16, height: 16 }} className="mr-1.5" />}
          Invia anteprima a me
        </Button>
      </div>
    </div>
  );
}
